export default "__VITE_ASSET__DoYTtPvM__"